
import { Icon } from "@iconify/react/dist/iconify.js";
import Image from "next/image";
import React from "react";

type Props = {};

const servicedata = [
  {
    icon: <Icon icon="icon-park-outline:correct"></Icon>,
    name: "Personalized Service",
  },
  {
    icon: <Icon icon="icon-park-outline:correct"></Icon>,
    name: "Destination Knowledge",
  },
  {
    icon: <Icon icon="icon-park-outline:correct"></Icon>,
    name: "Hassle-Free Planning",
  },
  {
    icon: <Icon icon="icon-park-outline:correct"></Icon>,
    name: "24/7 Support",
  },
  {
    icon: <Icon icon="icon-park-outline:correct"></Icon>,
    name: "Customer Satisfaction Guaranteed",
  },
];


export default function ServicesHome({}: Props) {
  return (
      <div className="lg:w-11/12 w-11/12 3xl:w-8/12 mx-auto grid lg:grid-cols-4 md:grid-cols-2  place-items-center py-10">
        <div className="flex flex-col gap-5">
        <h2 className="uppercase font-extrabold title lg:text-[2.8em] leading-[1em] text-[1.5em]">Why Choose Us?</h2>

          <p className="md:text-base text-sm  text-zinc-700 desc">
            With years of experience in the travel industry, we understand that
            every traveler is unique, and so are their adventures. Our
            personalized itineraries are crafted to suit your preferences,
            ensuring that every moment is tailored to your desires
          </p>

          <div className="flex flex-col gap-3 mt-4 desc">
            {servicedata.map((item) => (
              <div
                key={item.name}
                className="flex gap-2 justify-start items-center"
              >
                <div className="w-8 h-8 bg-orange-500 p-2 rounded-full text-white">
                  {item.icon}
                </div>
                <p className="text-medium text-sm font-semibold">{item.name}</p>
              </div>
            ))}
          </div>
        </div>

        {/* img  */}
        <div className="relative w-full overflow-hidden lg:block hidden col-span-2">
          <div className="absolute bottom-0 z-10 left-0 w-full h-[6vw] bg-gradient-to-t from-white via-white/90 to-transparent"></div>
          <div className="absolute bottom-0 z-10 left-0 w-full h-[20em] bg-gradient-to-t from-white via-white/90 to-transparent"></div>
          <Image
            width={5000}
            height={5000}
            src="/newchoose.png"
            alt=""
            className="w-full h-screen object-contain "
          ></Image>
        </div>

        <div className="md:flex hidden flex-col gap-8 desc">
          <div className="flex gap-3 items-start">
            <Icon
              icon="game-icons:life-jacket"
              className="min-w-14 min-h-14 bg-white p-3 rounded-full text-orange-400  border border-zinc-400"
            ></Icon>

            <div className="flex flex-col gap-1">
              <span className="text-lg font-semibold">Excellent Security</span>
              <p className="md:text-base text-xs text-zinc-700">
                Your safety is our top priority. We have rigorous security
                protocols in place to ensure you can travel worry-free, from the
                moment you book until your journey ends.
              </p>
            </div>
          </div>
          <div className="flex gap-3 items-start">
            <Icon
              icon="solar:hand-money-outline"
              className="min-w-14 min-h-14 bg-white p-3 rounded-full text-orange-400  border border-zinc-400"
            ></Icon>

            <div className="flex flex-col gap-1">
              <span className="text-lg font-semibold">Cost Efficiency</span>
              <p className="md:text-base text-xs text-zinc-700">
                Travel the world without breaking the bank. Our affordable
                packages are designed to offer maximum value, with no compromise
                on quality or experience.
              </p>
            </div>
          </div>
          <div className="flex gap-3 items-start">
            <Icon
              icon="gis:route"
              className="min-w-14 min-h-14 bg-white p-3 rounded-full text-orange-400 border border-zinc-400"
            ></Icon>

            <div className="flex flex-col gap-1">
              <span className="text-lg font-semibold">World Wide Route</span>
              <p className="md:text-base text-xs text-zinc-700">
                With a vast network of global destinations, we provide you
                access to breathtaking locations across every continent.
                Wherever your dream destination lies, we'll take you there.
              </p>
            </div>
          </div>
        </div>
      </div>
  );
}
